export default __webpack_public_path__ + "static/media/3695bb1e6d443d8e.3a8fb1125f745503bfa8c0fca3306ac3.svg";